<template>
  <div class="activity-template-preview">
    <div class="activity-template-preview__stage">
      <StudioEditor
        class="activity-template-preview__editor"
        embedded
        height="100%"
        mode="VIEW"
        :use-immersive-reader="false"
        :progress-tracking="progressTracking"
        :events-enabled="false"
      />
    </div>
    <BoardNavigationOverlay />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import BoardNavigationOverlay from '@/components/navigation/BoardNavigationOverlay.vue';

const StudioEditor = defineAsyncComponent(() => import(/* webpackChunkName: "editor" */'@/views/StudioEditor.vue'));

export default {
  name: 'ActivityTemplateModalPreview',
  components: {
    BoardNavigationOverlay,
    StudioEditor,
  },
  data() {
    return {
      progressTracking: {
        enabled: false,
      },
    };
  },
};
</script>

<style lang="stylus">
.activity-template-preview {
  border-radius: $nebula-border-radius-button-default;
  overflow: hidden;
  padding-top: 56%; // lock aspect ratio to approx. 16x9
  position: relative;

  &__stage {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  &__editor {
    height: 100%;
  }
}
</style>
